import { useState } from "react";
import Button from "components/ui/buttons/Button/Button";
import styles from "./PromoCodeSection.module.scss";
import { useCart } from "lib/hooks/useCart";
import PromoCodeChip from "./PromoCodeChip";

export default function PromoCodeEntry({}) {
  const [promoCode, setPromoCode] = useState();
  const [sendingPromoCode, setSendingPromoCode] = useState(false);
  const [promoCodeOk, setPromoCodeOk] = useState(false);

  const { cart, updatePromoCode, refreshCart } = useCart();
  const { promoCode: cartPromoCode } = cart;

  const handleApplyPromoCodeClick = async () => {
    setSendingPromoCode(true);

    const response = await updatePromoCode({ promoCode });

    if (response?.error === false) {
      setPromoCodeOk(true);
    }

    setSendingPromoCode(false);

    refreshCart();
  };

  return (
    <>
      <div className={`${styles.promoCodeContainer}`}>
        <div className={`${styles.promoCodeInputWrapper}`}>
          <label htmlFor="promo-code-input" className={`${styles.label}`}>
            Voucher Code
          </label>
          <input
            type="text"
            name="promo-code-input"
            id="promo-code-input"
            className={`${styles.promoCodeInput}`}
            // value={promoCode}
            onChange={(event) => setPromoCode(event.target.value)}
          />
        </div>
        <div className={`${styles.promoCodeButtonWrapper}`}>
          <Button
            fill="transparentBorderLight"
            classes={[`${styles.promoCodeButton} apply-promo-code-button`]}
            onClick={handleApplyPromoCodeClick}
            disabled={sendingPromoCode}
          >
            Apply
          </Button>
        </div>
      </div>
      <div className={`${styles.appliedPromoCode}`}>
        {cartPromoCode && <PromoCodeChip code={cartPromoCode} />}
      </div>
    </>
  );
}
